<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <reminder-insurance-table
            ref="reminder_insurance_table"
            title="ลูกค้าที่ต้องต่ออายุทั้งหมด"
            :insurances.sync="insurances"
            :total.sync="paginate.total"
            :page.sync="paginate.page"
          ></reminder-insurance-table>
          <base-pagination
            :total="paginate.total"
            :perPage="paginate.perPage"
            class="mt-2 d-flex justify-content-end"
            v-model="paginate.page"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReminderInsuranceTable from "./Tables/ReminderInsuranceTable";
// import axios from "axios";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "customerInsuranceReminder",
  mixins: [kickMixin],
  components: {
    ReminderInsuranceTable,
  },
  data() {
    return {
      keyword: "",
      insurances: [],
      paginate: {
        total: 0,
        page: 1,
        perPage: 30,
      },
    };
  },
  methods: {
    // loadAlmostExpired: function() {
    //   var localApp = this;
    //   axios
    //     .get(
    //       "/api/insurance/expired?page=" +
    //         localApp.paginate.page,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.token,
    //         },
    //       }
    //     )
    //     .then(function(response) {
    //       localApp.insurances = response.data.data.data;
    //       localApp.paginate.total = response.data.data.total;
    //     })
    //     .catch(function() {
    //       localApp.kick();
    //     });
    // },
    search: async function(e) {
      let localApp = this;
      e.preventDefault();
      localApp.$refs.reminder_insurance_table.advanceSearch(localApp.keyword);
      // await axios
      //   .get(
      //     "/api/insurance/searchAlmostExpired/q?keyword=" +
      //       localApp.keyword +
      //       "&page=" +
      //       localApp.paginate.page +
      //       "&month=" +
      //       localApp.$refs.reminder_insurance_table.selectedMonth +
      //       "&year=" +
      //       localApp.$refs.reminder_insurance_table.selectedYear +
      //       "&agent=" +
      //       localApp.$refs.reminder_insurance_table.selectedAgent,
      //     {
      //       headers: {
      //         Authorization: "Bearer " + localStorage.token,
      //       },
      //     }
      //   )
      //   .then(function(response) {
      //     localApp.insurances = response.data.data.data;
      //     localApp.paginate.total = response.data.data.total;
      //   })
      //   .catch(function(error) {
      //     alert(error);
      //   });
    },
  },
  // watch: {
  //   "paginate.page": function() {
  //     this.loadAlmostExpired();
  //   },
  // },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      // this.loadAlmostExpired();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
</style>
